/*
 * Schermafbeeldingen maken — tijdelijk hulpmiddel, geen onderdeel van de winkel.
 *
 * Doet niets tenzij er ?shot=1 in de URL staat. Dan verbergt het de
 * cookiebanner en de nieuwsbriefpopup, zodat een schermafbeelding het ontwerp
 * toont in plaats van twee overlays.
 *
 * Verbergen en niet wegklikken: wegklikken zet een voorkeur, en die hoort niet
 * gezet te worden door een hulpmiddel.
 *
 * Mag weg samen met collett-fonttest.js zodra het ontwerp vaststaat.
 */

(() => {
  if (new URLSearchParams(location.search).get('shot') !== '1') return;

  const css = `
    #shopify-pc__banner,
    .shopify-pc__banner,
    #shopify-pc__prefs,
    .shopify-section--newsletter-popup,
    [data-fonttest-paneel] {
      display: none !important;
    }
  `;

  const stijl = document.createElement('style');
  stijl.textContent = css;
  document.head.appendChild(stijl);

  // De popup wordt soms na het laden ingevoegd; blijf even opruimen.
  const opruimen = () => {
    document
      .querySelectorAll('.shopify-section--newsletter-popup, #shopify-pc__banner')
      .forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
      });
  };

  opruimen();
  const loper = setInterval(opruimen, 300);
  setTimeout(() => clearInterval(loper), 6000);

  // ?menu=<begin van de menutitel> klapt dat mega-menu open, zodat een
  // schermafbeelding het menu laat zien. Zonder dit is er geen manier om er in
  // een headless browser bij te komen.
  const menu = new URLSearchParams(location.search).get('menu');
  if (!menu) return;

  const openen = () => {
    const doel = [...document.querySelectorAll('header details')].find((d) =>
      (d.querySelector('summary')?.textContent || '')
        .trim()
        .toLowerCase()
        .startsWith(menu.toLowerCase())
    );
    if (!doel) return false;

    doel.setAttribute('open', '');
    doel.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    return true;
  };

  if (!openen()) setTimeout(openen, 600);
})();
